import { useParams } from "react-router-dom";
import styled from "styled-components";
import { CenterView } from "../../Component/style/common_style";
import Layout_user from "../../Component/UI/Layout_user";
import { useRule } from "./rule_use";
import { usePrivate } from "./rule_private";
import { fontStyles } from "../../Component/style/common_font";

const Topbar = styled(CenterView)`
  position: absolute;
  box-sizing: border-box;
  top: 0;
  width: 100%;
  max-width: 500px;
  padding: 1rem;
  font-size: 20px;
  ${fontStyles.Bold}
  color: #2d2d2d;
  background-color: white;
`;
const Content = styled.div`
  padding: 4rem 1rem;
  font-size: 14px;
  white-space: pre-line;
`;

const Rule = () => {
  const { type } = useParams();

  const ruletitle = type === "1" ? "이용약관" : "개인정보 처리방침";
  const ruletext = type === "1" ? useRule : usePrivate;

  return (
    <Layout_user background="white">
      <Topbar className="end">{ruletitle}</Topbar>

      <Content>
        <div>{ruletext}</div>
      </Content>
    </Layout_user>
  );
};

export default Rule;
